































































import { Component, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import PaymentState from '@/components/Accounts/Shared/Payments/PaymentState.vue';
import PaymentStateModel from '@/models/Accounts/Shared/Payments/PaymentState';
import PaymentDetailsDialog from '@/components/Accounts/Shared/Payments/PaymentDetailsDialog.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'PaymentOrderPayments', components: { PaymentState, PaymentDetailsDialog } })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    isCustomerAccount: boolean;

    @Prop({required: true})
    paymentOrderId: string;

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.payeeName'), width: "25%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.reference'), width: "25%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.amount'), width: "15%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.scheme'), width: "15%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.state'), width: "10%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.moreInfo'), width: '10%', sortable: false },
    ];

    get payments() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.paymentsForPaymentOrder;
        }
        else {
            return InstitutionAccountModule.paymentsForPaymentOrder;
        }
    }

    get loading() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.loadingPaymentsForPaymentOrder;
        }
        else {
            return InstitutionAccountModule.loadingPaymentsForPaymentOrder;
        }
    }

    get allowCancelPayment() {
        // Search the payments to find at least one scheduled payment since only scheduled payments can be cancelled
        const hasScheduledPayments = this.payments.find((payment) => {
            return payment.state === PaymentStateModel.Scheduled;
        });
        // Check feature toggle
        const isToggleEnabled = PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CancelPayments);
        // Allow cancel payment if this is a customer account, there are scheduled payments and the toggle is enabled
        return this.isCustomerAccount && hasScheduledPayments && isToggleEnabled;
    }

    async cancelAllPayments() {
        this.dialog = false;
        await DepositAccountModule.cancelAllPaymentsInPaymentOrder(this.paymentOrderId);
        // TODO: Refresh payments view
    }

    async close() {
        this.dialog = false;
    }

}
